export const DOCUMENT_TYPE_FOR_PACKAGE = 258;
export const DOCUMENT_TYPE_FOR_REQUEST = 251;
export const DOCUMENT_TYPE_FOR_BASE_AGREEMENT = 10004;